import { useStaticData } from '@mc/static-data-react'
import { TrackingContainer } from '@mc/visibility'
import { CourseMeta, Outcome, OutcomeContent } from 'types/data'
import { getFeaturedInstructors, useOutcomePageEvents } from '../../utils'
import { HeroDesktop } from '../HeroDesktop'
import { HeroMobile } from '../HeroMobile'

export const Hero = () => {
  const { outcome, outcomeRankedContent, courseSlugToMeta } = useStaticData<{
    outcome: Outcome
    outcomeRankedContent: OutcomeContent[]
    courseSlugToMeta: Record<string, CourseMeta>
  }>()

  const { trackHeroViewed } = useOutcomePageEvents()

  const [featuredInstructor1, featuredInstructor2] = getFeaturedInstructors(
    outcome,
    outcomeRankedContent,
    courseSlugToMeta,
  )

  const heroProps = {
    heading: outcome.name,
    subheading: outcome.oneLiner,
    img1Url: featuredInstructor1?.imageUrl,
    img1Alt: featuredInstructor1?.name,
    img2Url: featuredInstructor2?.imageUrl,
    img2Alt: featuredInstructor2?.name,
  }

  return (
    <TrackingContainer onFirstVisible={() => trackHeroViewed(outcome.name)}>
      <HeroMobile {...heroProps} />
      <HeroDesktop {...heroProps} />
    </TrackingContainer>
  )
}
